import { AmountInput, Icon } from '@components';
import CurrencyAmount from '@components/currency-amount/CurrencyAmount';

import theme from '../../../themes/colors';

interface AmountChangeParams {
  value: string;
  index: number;
  categoryName: string;
}

interface FeeConfigInputProps {
  feeCategories: { category: string; amount: string }[];
  onCategoryAmountChange: (params: AmountChangeParams) => void;
  memberActionType: 'add' | 'edit';
  isWarningRequired?: boolean;
  titleStyle?: string;
}

const FeeConfigInput = ({
  feeCategories,
  onCategoryAmountChange,
  memberActionType,
  isWarningRequired = true,
  titleStyle = 'text-base'
}: FeeConfigInputProps) => {
  const nonZeroItems = feeCategories.filter(
    ({ amount }) => Number(amount) !== 0
  );

  return (
    <div className="pb-2">
      <div className="mt-4 flex w-full gap-6">
        <div className={`w-1/2 ${titleStyle} text-grey`}>Category</div>
        <div className={`w-1/2 ${titleStyle} text-grey`}>Amount</div>
      </div>
      {feeCategories.map(({ category, amount }, index) => (
        <div key={category} className="mt-3 flex w-full gap-6">
          <div className="w-1/2 rounded-lg bg-grey10 px-4 py-3 text-base text-content">
            {category}
          </div>
          <div className="w-1/2 text-base text-content">
            <AmountInput
              value={amount}
              onAmountChange={(newValue) => {
                if (
                  memberActionType === 'edit' &&
                  Number(newValue) === 0 &&
                  nonZeroItems.length === 1 &&
                  Number(amount) !== 0
                ) {
                  return;
                }
                onCategoryAmountChange({
                  index,
                  value: newValue,
                  categoryName: category
                });
              }}
              allowZero
            />
          </div>
        </div>
      ))}
      {isWarningRequired && (
        <div className="flex items-center gap-1 py-4 text-base text-grey">
          <Icon name="alert-circle" stroke={theme.subText} />
          If a fee doesn&apos;t apply, enter &quot;
          <span className="inline-flex items-baseline">
            <CurrencyAmount value={0} symbolClass="!mr-0.5" />
          </span>
          &quot;
        </div>
      )}
    </div>
  );
};

export default FeeConfigInput;
